<template>
    <v-snackbar
            v-if="snackbar"
            multi-line
            v-model="snackbar"
            :timeout="timeout"
            color="white">{{ text }}
        <v-btn color="secondary"
               @click="close()">
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: "Snackbar",
        props: ['text'],
        data: () => ({
            timeout: 10000,
            snackbar: false
        }),
        methods: {
            close() {
                this.snackbar = false
            },
            openSnackbar() {
                this.snackbar = true
            }
        },
    }
</script>

<style scoped>

</style>
